/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconArrowDown extends React.Component {
  render() {
    const iconClasses = classNames("icon arrow-down", this.props.className);

    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path
          d="M 24.990234 8.9863281 A 1.0001 1.0001 0 0 0 24.292969 9.2929688 L 15 18.585938 L 5.7070312 9.2929688 A 1.0001 1.0001 0 0 0 4.9902344 8.9902344 A 1.0001 1.0001 0 0 0 4.2929688 10.707031 L 14.292969 20.707031 A 1.0001 1.0001 0 0 0 15.707031 20.707031 L 25.707031 10.707031 A 1.0001 1.0001 0 0 0 24.990234 8.9863281 z"
          fontWeight="400"
          fontFamily="sans-serif"
          overflow="visible"
        />
      </svg>
    );
  }
}

IconArrowDown.defaultProps = {
  className: null
};

IconArrowDown.propTypes = {
  className: PropTypes.string
};

export default IconArrowDown;
